module.exports = __webpack_public_path__ + "img/pricing-banner.e01f8584.webp";